export const SET_ERROR = "SET_ERROR";


// WEBPACK FOOTER //
// ./src/constants/app.js